var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpLight = function SvgArrowUpLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52673 0.806572L0.466729 3.86657C0.206729 4.12657 0.206729 4.54657 0.466729 4.80657C0.726729 5.06657 1.14673 5.06657 1.40673 4.80657L4.00006 2.21991L6.58673 4.80657C6.84673 5.06657 7.26673 5.06657 7.52673 4.80657C7.78673 4.54657 7.78673 4.12657 7.52673 3.86657L4.46673 0.806572C4.2134 0.546572 3.78673 0.546572 3.52673 0.806572Z"
  })));
};
export default SvgArrowUpLight;